import script from "./shuoming.vue?vue&type=script&setup=true&lang=js"
export * from "./shuoming.vue?vue&type=script&setup=true&lang=js"

import "./shuoming.vue?vue&type=style&index=0&id=41db8a49&scoped=true&lang=css"

import exportComponent from "D:\\doc\\project\\lunwenzhinengtougaopingtaitest2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41db8a49"]])

export default __exports__